module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00005.382cfd4.png";